import { Flex } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import GroupButton, { ActionButton } from "components/ui/GroupButton/GroupButton";
import { SearchInput } from "components/ui/SearchInput/SearchInput";
import CustomText from "components/ui/CustomText/CustomText";
import { CommonParamsType } from "constants/types/common";
import { FORM_IDS } from "pages/Region/config";
import { FC, useRef } from "react";
import { useSWRConfig } from "swr";
import { useAppModal } from "utils/hooks/ui/useAppModal";
import { getRegionListKey } from "utils/hooks/request/useRegions";
import CreateForm from "../CreateForm/CreateForm";

type RegionActionsProps = {
  handleSearch: (v: string) => void;
  params: CommonParamsType;
};

const RegionActions: FC<RegionActionsProps> = ({ handleSearch, params }) => {
  const { openCrudModal, closeCrudModal } = useAppModal();
  const activeModalId = useRef<string | null>(null);
  const { mutate } = useSWRConfig();

  const handleCloseModal = () => {
    if (activeModalId.current) {
      closeCrudModal(activeModalId.current);
      activeModalId.current = null;
    }
  };

  const handleOpenCreateModal = () => {
    const modalId = openCrudModal(
      <CustomText variant="section-title">Tạo mới địa bàn</CustomText>,
      {
        mode: "create",
        formId: FORM_IDS.CREATE,
        children: (
          <CreateForm
            mutate={() => mutate(getRegionListKey(params))}
            onClose={handleCloseModal}
          />
        ),
        submitText: "Tạo mới",
      },
      500,
    );
    activeModalId.current = modalId;
  };

  const actions: ActionButton[] = [
    {
      key: "create",
      label: "Tạo mới",
      icon: <IconPlus size={18} />,
      variant: "filled",
      color: "blue",
      isLoading: false,
      onClick: handleOpenCreateModal,
      permission: "region:create",
    },
  ];

  return (
    <Flex justify="space-between" align="center">
      <SearchInput
        value={params.search || ""}
        onChange={handleSearch}
        placeholder="Tìm kiếm thông tin địa bàn"
      />
      <GroupButton actions={actions} />
    </Flex>
  );
};

export default RegionActions;
